import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { deleteData } from '../controller';
import { requestHandler } from '../helper';

function DeleteModal({ id, endPoint, onSuccess, title }) {

    const [show, setShow] = useState(false);
    const [Id, setId] = useState(null);
    const handleClose = () => {
        setShow(false);
        setId(null);
    };

    const handleShow = () => {
        setShow(true);
        setId(id);
    };

    const handleDelete = async () => {

        await requestHandler(
            async () => await deleteData(endPoint, id),
            null,
            (res) => {
                toast.success(res.message);
                handleClose();
                onSuccess();
            },
            () => { }
        )

    };

    return (
        <>
            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Delete</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/delete.png" alt="" />
                </button>
            </OverlayTrigger>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Delete {title}</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <p className='delete'>Are you sure you want to delete {title}?</p>
                        <div className='d-md-flex align-items-center gap-3 mt-4'>
                            <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                            <button className='save-btn' onClick={handleDelete}>Delete</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DeleteModal